import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';

import { offerStatus, getOfferStatus } from '../../../helpers/offer-status-helper';

const OfferInfo = ({ offer, deleteOffer }) => {
    let currentOfferStatus = offer.benefitSelected === undefined ? "STD"
        :
        getOfferStatus(offer.benefitSelected, offer.initiatorSelected, offer.senttoSupplier);
    const handleClose = () => {
        setOpen(false);
    };
    const [open, setOpen] = useState(false);
    return (
        <>
            {
                open === true ?
                    <Dialog
                        open={open}
                        onClose={handleClose}
                    >
                        <DialogTitle>{"Are you sure you want to delete this offer?"}</DialogTitle>
                        <DialogActions>
                            <Button onClick={handleClose} color="primary">
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                className="contain-danger"
                                onClick={deleteOffer}
                                autoFocus
                            >
                                Sure
                            </Button>
                        </DialogActions>
                    </Dialog>
                    : null
            }
            <Typography variant="h6" gutterBottom>
                Offer
            </Typography>
            <Typography variant="body1" gutterBottom>
                Status <b>{currentOfferStatus}</b>
            </Typography>
            <Typography variant="body2" gutterBottom>
                Offerd in <b>{new Date(offer.createDate).toDateString()}</b>
            </Typography>
            <Typography variant="body2" gutterBottom>
                Time of offer <b>{offer.createDate.substring(11, 16)}</b>
            </Typography>
            <Typography variant="body2" gutterBottom>
                Offered by  <b>{offer.createdBy}</b>
            </Typography>

            {
                currentOfferStatus === offerStatus.UnderRevision || currentOfferStatus === "STD" ?
                    <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        className="contain-danger"
                        onClick={() => setOpen(true)}
                    >Delete Offer</Button>
                    : null
            }
        </>
    );
}

export default OfferInfo;